var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02637 14.6667C3.02637 9.32412 3.02637 6.65284 4.68609 4.9931C6.34583 3.33337 9.01711 3.33337 14.3597 3.33337H20.0264C25.3689 3.33337 28.0403 3.33337 29.6999 4.9931C31.3597 6.65284 31.3597 9.32412 31.3597 14.6667V16.0834C31.3597 20.0903 31.3597 22.0937 30.1149 23.3385C28.8701 24.5834 26.8666 24.5834 22.8597 24.5834H11.5264C7.51943 24.5834 5.51596 24.5834 4.27116 23.3385C3.02637 22.0937 3.02637 20.0903 3.02637 16.0834V14.6667Z",
    stroke: "#313131",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8597 31.6666H11.5264",
    stroke: "#313131",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1934 24.5834V31.6667",
    stroke: "#313131",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3597 18.9166H3.02637",
    stroke: "#313131",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/icon-monitor.09a990fd5d513a20f3390549394fc753.svg";
export { ForwardRef as ReactComponent };